<template>
  <div :class="`tax-wrap ${multi ? 'multi' : ''}`">
    <div class="tax-wrap-header">
      <img src="../assets/ebarimt.png" alt="tax" style="color:white">
    </div>

    <div class="tax-wrap-body" v-if="taxData != null">
      <table >
        <tr>
          <td>Огноо:</td>
          <td>{{ taxData.date }}</td>
        </tr>

        <tr>
          <td>ДДТД:</td>
<!--          <td>{{ taxData.id }}</td>-->
          <td style="width: 80px; word-wrap: break-word; overflow-wrap: break-word;">{{ taxData.id }}</td>
        </tr>

        <tr>
          <td>Нийт дүн:</td>
          <td>{{ new Intl.NumberFormat().format(taxData.totalAmount) }} ₮</td>
        </tr>

        <tr>
          <td>НӨАТ:</td>
          <td>{{ new Intl.NumberFormat().format(taxData.totalVAT) }} ₮</td>
        </tr>

        <tr v-if="multi">
          <td>Сугалаа:</td>
          <td>{{ taxData.lottery }}</td>
        </tr>

      </table>
    </div>
    <div class="tax-wrap-footer">
      <div class="qr-image">
        <vue-qrcode class="desk" width="120" height="120" :value="taxData.qrData"/>
      </div>
      <div v-if="!multi" class="number">
        <span>Сугалааны дугаар</span>
        <span>{{ taxData.lottery }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  components: {
    VueQrcode
  },
  props: ['taxData', 'multi'],
  name: "EBarimtItem",
  created() {
    console.log('taxData',this.taxData)
  }
}
</script>
